import Vue from 'vue';
import Vuex from 'vuex';
import CartModule from './modules/cart';
import MiniCartModule from './modules/miniCart';
import ShopContent from './modules/shopContent';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    cartModule: CartModule,
    miniCartModule: MiniCartModule,
    shopContent: ShopContent,
  },
});

export default store;
